import { render, staticRenderFns } from "./teach.vue?vue&type=template&id=b08bbe26&scoped=true"
import script from "./teach.vue?vue&type=script&lang=js"
export * from "./teach.vue?vue&type=script&lang=js"
import style0 from "./teach.vue?vue&type=style&index=0&id=b08bbe26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08bbe26",
  null
  
)

export default component.exports